import React, { useState, useEffect } from "react"
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput"
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete"
import { customStyle, getPdcCost, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from "./constant"
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2"
import { ReactComponent as UploadIcon } from "assets/img/svg/upload.svg";
import { ReactComponent as DonloadIcon } from "assets/img/svg/downloadBlackV2.svg";
import moment from "moment"
import { Col, Label, Row } from "reactstrap"
import Error from "../errorHandlimg/Error"
import { chequeDDValidation, chequeValidation, pdcValidation } from "../validations/paymentModeValidation"
import DocUploadModal from "../../../studentCharges/studentChargesDetails/paymentMode/DocUploadModal"
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import { ReactComponent as PdfIcon } from "assets/img/svg/pdfIcon.svg"
import "./style.scss";
import { CHEQUE_ERROR_MESSAGES, PDC_HANDLING_MESSAGES } from "../validations/validationMessage"
import { getConditionalCOllectSaveButton, WarningDialog } from "./common"
import { downloadAttachment } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/utils"
import { regex } from "views/pages/manage/common/constant"
import { formattedPrice } from "../../utils"
const ChequeView = ({ isEditForm, isReceiptEdit = false, isView = false, contextValue, rowId, handleClose }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [errorMgs, setErrorMgs] = useState('');
    const [warningMsg, setWarningMsg] = useState();
    const [isWarningOpen, setWarningOpen] = useState(false)
    const [pdcCost, setPdcCost] = useState("")

    const {
        setPaymentModeForm,
        bankDropdown,
        paymentModeFormHandler,
        studentBasicDetails,
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        setModifyPaymentModeData,
        selectedCharges,
        validatePaymentMode,
        disableAmountField
    } = contextValue;
    
    // useEffect(() => {
    //     getPdcHandlingCost()
    // }, [])
    const getPdcHandlingCost = async () => {
        setloader(true)
        const isPdcValid = pdcValidation(studentBasicDetails,selectedCharges)
        const data = isPdcValid && await getPdcCost("PDC_CHARGE", studentBasicDetails)
        setPdcCost(data?.netPayableAmount)
        setloader(false)
    }

    const validatePayment = async () => {
        const error = chequeDDValidation(paymentModeForm, collectPayment, currentPaymentMode, balanceAmount)
        setErrorMgs(error)
        if (!error) {
            if (warningMsg) {
                setWarningOpen(true)
            }
            else
                validationHandler()
        }

    }

    const validationHandler = async () => {
        const isOk = await validatePaymentMode(studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, '', setBalanceAmount, setBalanceMode, setloader, setCollectPayment, balanceAmount, collectPayment);
        // PHX-11246 
        if (currentPaymentMode === 'cheque') paymentModeForm.paymentMode = 'cheque'
        if (isOk) {
            isReceiptEdit === true && setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
            isReceiptEdit && handleClose(true)
        }
    }
    const disabled = !(paymentModeForm?.paidAmount && paymentModeForm?.referenceNumber && paymentModeForm?.paymentModeDate && paymentModeForm?.bank && paymentModeForm?.paymentModeAttachmentS3Key)

    return (
        <>
            {(!isView && !isReceiptEdit) && <div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">Cheque</span>
                <div className="d-flex justify-content-between align-items-center"><span className="large-semi-bold color-primary mr-1">Scan Cheque</span> <Scanner /></div>
            </div>
            }
            <Row>
                <Col md="4">
                    <div>
                        <AInput
                            label="Enter amount"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.paidAmount}
                            handler={(value) => {
                                if (
                                    !value || parseFloat(value) > 0
                                ) {
                                    paymentModeFormHandler('paidAmount', value)
                                }

                            }}
                            customIcon={
                                <div className='large-semi-bold'>&#8377;</div>
                            }
                            customIconStyle={customStyle}
                            placeholder="Enter amount"
                            style={inputAmountStyle}
                            disabled={isView || isReceiptEdit === true || disableAmountField}
                            regex={numberDecimalLimitRegex(8, 2)}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                        <AInput
                            label="Cheque Number"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.referenceNumber}
                            handler={(value) => { paymentModeFormHandler("referenceNumber", value) }}
                            maxLength={6}
                            placeholder="Enter cheque number"
                            style={{ height: "47px", width: '265px', borderRadius: "5px", borderColor: errorMgs == CHEQUE_ERROR_MESSAGES.CHEQUE_NUMBER ? 'red' : '' }}
                            disabled={isView}
                            regex={regex.numeric}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                        <AAutoComplete
                            label="Bank"
                            labelStyle={labelSyle}
                            placeholder="Select bank"
                            currentValue={paymentModeForm?.bank}
                            handleChange={(value) => { paymentModeFormHandler("bank", value) }}
                            items={bankDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isInputChange={true}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Cheque date"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select date"
                            value={paymentModeForm?.paymentModeDate}
                            handler={(index, date) => {
                                paymentModeFormHandler("paymentModeDate", date);
                                // if ((new Date(date)) > (new Date()) && pdcCost) {
                                //     setWarningMsg(PDC_HANDLING_MESSAGES?.PDC_HANDLING(pdcCost))
                                // }
                                // else
                                //     setWarningMsg('')
                            }
                        }
                            isStartDate={true}
                            minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                            // maxDate={new moment(new Date())}
                            disabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <Label style={{ ...labelSyle, marginTop: '7px' }}>
                        Cheque Photo
                    </Label>
                    {(paymentModeForm?.paymentModeAttachmentS3Key || isView) ?
                        <div style={{ gap: '10px' }} className="d-flex mt-2 cursor">
                            {paymentModeForm?.fileName && <span><PdfIcon height={22} width={18} /></span>}
                            <span className="large-semi-bold">{isView ? <span className="regular-large-bold label-color">{paymentModeForm?.fileName ?? '-'}
                                {paymentModeForm?.fileName && <DonloadIcon width='24px' height='24px' onClick={() => downloadAttachment(paymentModeForm?.fileName,"CHEQUE_DD",paymentModeForm?.removeErpDependencyProp)} />}
                            </span> : paymentModeForm?.fileName}</span>
                            {!isView && <span><EditIcon onClick={() => { setIsOpen(true) }} /></span>}
                        </div> :
                        <div className="upload-btn " onClick={() => { setIsOpen(true) }}>
                            <UploadIcon /> Upload
                        </div>}


                </Col>
            </Row>
            {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
            <Error errorMgs={errorMgs} warningMsg={warningMsg} />
            <DocUploadModal
                open={isOpen}
                setOpen={setIsOpen}
                saveHandler={(s3Key, fileName) => {
                    setIsOpen(false);
                    setPaymentModeForm({ ...paymentModeForm, paymentModeAttachmentS3Key: s3Key, fileName: fileName })
                }}
                acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                maxUploadFileSize={2}
                serviceName={'PAYMENT_COLLECTION_ATTACHMENTS'}
                uniqueKeyParameter={"paymentCollectionImage"}
                uploadedFileS3Key={paymentModeForm?.paymentModeAttachmentS3Key}
                uploadedFileName={paymentModeForm?.fileName}
                modalTitle={"Upload Cheque photo"}
                propStyle={{ overflow: 'auto', maxWidth: '325px' }}

            />
            {pdcCost && <WarningDialog
                open={isWarningOpen}
                setOpen={setWarningOpen}
                title={"Additional charge confirmation"}
                subheading={`You are trying to receipt from cheque mode. As per the process, an additional charge of ${formattedPrice(Math.round(Number(pdcCost)))} will be applied upon confirmation`}
                confirmHandler={validationHandler}

            />}
        </>
    )
}
export default ChequeView